import React from 'react';

type ExpandArrowProps = {
  isCollapsed: boolean;
  toggle?: () => void;
};

const ExpandArrow: React.FC<ExpandArrowProps> = ({ toggle, isCollapsed }) => {
  return (
    <button className="button--icon sml border-0" onClick={toggle}>
      <i className="material-symbols-outlined">
        {isCollapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_down'}
      </i>
    </button>
  );
};

export default ExpandArrow;
